module.exports = __webpack_public_path__ + "static/media/piper-calendar-background.36322b8e.gif";